
<div class="sidebar">
    <mat-card class="navbar-top">
        <div class="logo">            
            <span class="logo-text secondary-text">flowtrics</span>       
        </div>
      
        <div class="menuopt">    
            <button mat-icon-button class="openbar" (click)="openSidebar()">              
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 232.7 232.7"><path class="logoSvg" d="M-315.8,188.25A116.48,116.48,0,0,0-432.15,304.6a115.89,115.89,0,0,0,8.27,43.21h0l.08.18c.73,1.8,1.49,3.59,2.31,5.36a116.46,116.46,0,0,0,6.77,12.52c.83,1.34,1.69,2.65,2.58,4,.69,1.09,1.37,2.12,2,3.09l.05.24c5.34,7.77,17.65,23.14,36.16,31.56a40.67,40.67,0,0,0,13.21,2.2,40.77,40.77,0,0,0,9.5-1.12,40.91,40.91,0,0,0,18.66-9c1-.85,2-1.75,3-2.71a43.3,43.3,0,0,0,5.22-6.3l.11-.16c.29-.42.57-.85.84-1.28A42.56,42.56,0,0,0-317,363.61c0-.15,0-.29,0-.44V340.22h.1v-12h16.55V314.64h-16.55V287.05a20.58,20.58,0,0,1,6.3-14.73,20.69,20.69,0,0,1,11.35-6h0l.34-.06c2.25-.34,15.11-1.69,21.27,10.14h22.47a40.89,40.89,0,0,0-26.28-30.22h0l-.06,0a40.85,40.85,0,0,0-13.65-2.34,41.31,41.31,0,0,0-9.5,1.11,41.55,41.55,0,0,0-21.62,11.69,43.92,43.92,0,0,0-6.17,7.75,42.47,42.47,0,0,0-6.42,22.76c0,.15,0,.29,0,.44v22.95h-.09v4.08h-16.58v13.62h16.58v35.46a20.58,20.58,0,0,1-6.3,14.74c-.39.38-.78.74-1.18,1.09s-.64.53-1,.78l-.22.18a19.63,19.63,0,0,1-2.49,1.62h0a21.14,21.14,0,0,1-2.2,1.06h0a14.08,14.08,0,0,1-8.14,1.44,17.15,17.15,0,0,1-4.65-.93c-5.06-1.59-11.39-5.41-18.55-13.64h0c-1.51-1.53-2.95-3.1-4.28-4.68A102,102,0,0,1-403.44,340a94.57,94.57,0,0,1-6.87-35.36,94.61,94.61,0,0,1,94.51-94.51,94.61,94.61,0,0,1,94.51,94.51,94.62,94.62,0,0,1-94.51,94.51c-1.37,0-2.78,0-4.21-.1l-6.27,5.27a50.79,50.79,0,0,1-22.85,11c-.48.12-1,.22-1.47.32a116.12,116.12,0,0,0,34.8,5.3A116.47,116.47,0,0,0-199.45,304.6,116.48,116.48,0,0,0-315.8,188.25Z" transform="translate(432.15 -188.25)"/></svg> 
            </button>    
            <button  mat-icon-button class="closebar">
                <mat-icon class="secondary-text" (click)="closeSidebar()">arrow_back</mat-icon>
            </button>           
        </div>    
    </mat-card>
    
    
    <div class="navbar-scroll-container">
        <div class="navbar-content">
            <ul>      
                <li *ngFor="let link of menuModulesList">
                    <a *ngIf="link.isAssign==true" (click)="linkclick(link)"  [ngClass]="{'active': link.orgModuleName == activeLinkName}">
                            <span class="iconTitle">
                            <mat-icon *ngIf="link.mainModuleName!=='Chat'">{{link.icon}}</mat-icon>
                            <mat-icon *ngIf="link.mainModuleName=='Chat' && ChatCount>0" matBadge={{ChatCount}} matBadgeColor="accent">{{link.icon}}</mat-icon>
                            <mat-icon *ngIf="link.mainModuleName=='Chat' && ChatCount==0">{{link.icon}}</mat-icon>
                    
                            <span class="linktitle">{{link.orgModuleName}}</span>
                        </span>
                        <span class="hover_title">{{link.orgModuleName}}</span>
                    </a> 

                    <!-- <ng-container *ngIf="showDashboard">
                        <a  (click)="linkclick('Dashboard')" [routerLink]="'/dashboard'" [ngClass]="{'active': activeLink == 'Dashboard'}">
                            <span class="iconTitle">
                                <mat-icon>dashboard</mat-icon>
                                <span class="linktitle">Dashboard</span>
                            </span>
                            <span class="hover_title">Dashboard</span>
                        </a> 
                    </ng-container>
                      
                    <ng-container *ngIf="mainModuleName">
                        <a  (click)="linkclick('Core')"
                        [ngClass]="{'active': activeLink == 'Core'}" >
                        <span class="iconTitle">
                            <mat-icon>app_registration</mat-icon>
                            <span class="linktitle">Core</span>
                        </span>
                        <span class="hover_title">Core</span>
                        </a> 
                    </ng-container>
                    
                    <ng-container *ngIf="showContact">
                    <a  (click)="linkclick('Contact')"
                    [ngClass]="{'active': activeLink == 'Contact'}" >
                        <span class="iconTitle">
                            <mat-icon>contact_mail</mat-icon>
                            <span class="linktitle">Contact</span>
                        </span>
                        <span class="hover_title">Contact</span>
                    </a> 
                   </ng-container>
                                   

                   <ng-container *ngIf="showCompany">
                    <a  (click)="linkclick('Company')"
                    [ngClass]="{'active': activeLink == 'Company'}">
                        <span class="iconTitle">
                            <mat-icon>business</mat-icon>
                            <span class="linktitle">Company</span>
                        </span>
                        <span class="hover_title">Company</span>
                    </a> 
                   </ng-container>


                <ng-container *ngIf="showForms">
                    <a  (click)="linkclick('Forms')"
                    [ngClass]="{'active': activeLink == 'Forms'}">
                        <span class="iconTitle">                          
                            <mat-icon>border_color</mat-icon>
                            <span class="linktitle">Forms</span>
                        </span>
                        <span class="hover_title">Forms</span>
                    </a> 
                </ng-container>
               
                
                <ng-container *ngIf="showDashboard">
                    <a (click)="linkclick('File Manager')"
                    [ngClass]="{'active': activeLink == 'File Manager'}">
                        <span class="iconTitle">
                            <mat-icon>folder_special</mat-icon>
                            <span class="linktitle">File Manager</span>
                        </span>
                        <span class="hover_title">File Manager</span>
                    </a> 
                </ng-container>
                    
              
                
                <ng-container *ngIf="showDashboard">
                    <a  (click)="linkclick('Chat')"
                    [ngClass]="{'active': activeLink == 'Chat'}">
                        <span class="iconTitle">
                            <mat-icon>chat</mat-icon>
                            <span class="linktitle">Chat</span>
                        </span>
                        <span class="hover_title">Chat</span>
                    </a> 
                </ng-container>


                <ng-container *ngIf="showTask">
                    <a  (click)="linkclick('Task')"
                    [ngClass]="{'active': activeLink == 'Task'}">
                        <span class="iconTitle">
                            <mat-icon>task</mat-icon>
                            <span class="linktitle">Task</span>
                        </span>
                        <span class="hover_title">Task</span>
                    </a>
                </ng-container>

                <ng-container  *ngIf="showCalender">
                    <a (click)="linkclick('Calendar')"
                    [ngClass]="{'active': activeLink == 'Calendar'}">
                        <span class="iconTitle">
                            <mat-icon>business_center</mat-icon>
                            <span class="linktitle">Doctor</span>
                        </span>
                        <span class="hover_title">Doctor</span>
                    </a> 
                </ng-container>

                <ng-container *ngIf="showCalender" >
                    <a  (click)="linkclick('Facility')"
                    [ngClass]="{'active': activeLink == 'Facility'}">
                        <span class="iconTitle">
                            <mat-icon>corporate_fare</mat-icon>
                            <span class="linktitle">Facility</span>
                        </span>
                        <span class="hover_title">Facility</span>
                    </a> 
                </ng-container>
                    -->
                </li>
              
            </ul>

            <ul>                            

                <li *ngFor="let link of adminSettingMenuList">
                  
                    <a  *ngIf="link.isAssign==true" (click)="linkclick(link)" [ngClass]="{'active': link.orgModuleName == activeLinkName}" >
                        <span class="iconTitle">
                            <mat-icon>{{link.icon}}</mat-icon>
                            <span class="linktitle">{{link.orgModuleName}}</span>
                        </span>
                        <span class="hover_title">{{link.orgModuleName}}</span>
                    </a>

                    <!-- <a  *ngIf="showAdminModule" (click)="linkclick('Admin')" routerLinkActive="active" [routerLink]="'/admin'">
                        <span class="iconTitle">
                            <mat-icon>supervised_user_circle</mat-icon>
                            <span class="linktitle">Admin</span>
                        </span>
                        <span class="hover_title">Admin</span>
                    </a>
                   
                    <a  *ngIf="showSettingModule" (click)="linkclick('Settings')" routerLinkActive="active" [routerLink]="'/settings'">
                        <span class="iconTitle">
                            <mat-icon>settings</mat-icon>
                            <span class="linktitle">Settings</span>
                        </span>
                        <span class="hover_title">Settings</span>
                    </a> -->

                  
                </li>
            </ul>
    
        </div>
    
    </div>
    
</div>
<div class="sidebarOverlay" (click)="closeSidebar()" ></div>